import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    container: { height: '100%' },
    header: {
        flexBasis: 'auto',
        flexShrink: 1
    },
    title: { marginRight: '.75rem' },
    subtitle: {
        paddingLeft: '.5rem',
        position: 'relative' as const
    },
    subtitleText: {
        width: 'fit-content',
        padding: '0 .75rem .25rem .75rem',
        borderBottom: `3px solid ${theme?.app?.clientTheme.colors.highlightColor3 ||
        '#B9D9EC'}`
    },
    exportButton: {
        position: 'absolute' as const,
        top: 0,
        right: '2rem'
    },
    exportIcon: {
        height: '16px',
        width: '24px'
    },
    grow: {
        flexGrow: 1,
        flexShrink: 0
    }
});